module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [(!_vm.isLoading) ? _c('mu-content-block', [_c('mu-breadcrumb', {
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('mu-breadcrumb-item', {
    attrs: {
      "href": "#/faq"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToFAQ.apply(null, arguments)
      }
    }
  }, [_vm._v("FAQs")]), _vm._v(" "), _c('mu-breadcrumb-item', [_vm._v(_vm._s(_vm.content.question))])], 1), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('mu-card', {
    staticClass: "top"
  }, [_c('mu-card-header', {
    attrs: {
      "title": _vm.content.question,
      "titleClass": "largeTitle blueTitle"
    }
  }), _vm._v(" "), (_vm.content.video_url !== null) ? _c('video', {
    staticStyle: {
      "margin-bottom": "16px",
      "width": "100%"
    },
    attrs: {
      "controlsList": "nodownload",
      "controls": "",
      "src": _vm.content.video_url
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-top": "0"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content.answer)
    }
  }), _vm._v(" "), _c('mu-card-actions', {
    staticClass: "grey",
    staticStyle: {
      "align-items": "center"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "position": "relative",
      "top": "-6px",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.labelRateThisAnswer')))]), _vm._v(" "), _c('mu-icon-button', {
    class: {
      'active': _vm.content.rating === 'UP'
    },
    attrs: {
      "color": "#767676",
      "icon": "thumb_up"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.upVote.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-icon-button', {
    class: {
      'inactive': _vm.content.rating === 'DOWN'
    },
    attrs: {
      "color": "#767676",
      "icon": "thumb_down"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.downVote.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": "28"
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7a6311c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Faq/Detail.vue
// module id = 3307
// module chunks = 1